/** Toggle sections on/off without deleting content. Set to true to show again. */
export const siteFlags = {
  showTestimonials: true,
  showCompanyLogos: true,
  showRefundPlacementFaq: false,
};